<template>
  <v-modal :title="`Agencia: ${agencia.nombre}`" :show="show" @close="$emit('close')" size="fluid" buttonClose="true">
    <ui-spinner v-if="loading.view"></ui-spinner>
    <template v-else>
      <div class="row form-row">
        <div class="col-lg-4">
          <div class="form-group">
            <label for="" class="form-label">Servicio *:</label>
            <InputSelect v-model="form.servicio" label="nombre" :reduce="(opt) => opt.idServicio" :options="containers.servicios" :disabled="!!containers.id"></InputSelect>
          </div>
          <div v-if="loading.servicioTipos" class="text-center">
            <i class="fa fa-fw fa-spin fa-circle-notch"></i>
          </div>
          <div class="form-group" v-if="containers.tipos.length">
            <label for="" class="form-label">Tipo:</label>
            <InputSelect label="sigla" :reduce="(opt) => opt.idServicioTipo" :options="containers.tipos" v-model="form.tipo" :disabled="!!containers.id"></InputSelect>
          </div>
          <div class="form-group">
            <div class="d-flex align-items-center">
              <div class="mr-3">
                Moneda
              </div>
              <div class="flex-fill">
                <InputSelect v-model="form.moneda" :options="containers.monedas" :reduce="(opt) => opt.sigla" label="sigla"> </InputSelect>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="precioPorPasajero" class="d-block mb-2">
              <input type="radio" id="precioPorPasajero" v-model="form.precioPor" :value="1" />
              Precio por pasajero
            </label>
            <label for="precioPorNumero" class="d-block mb-2">
              <input type="radio" id="precioPorNumero" v-model="form.precioPor" :value="0" />
              Varía según número de pasajeros
            </label>
          </div>

          <template v-if="form.precioPor === 1">
            <div class="form-group">
              <label for="precioDiferente" class="d-block mb-2">
                <input type="checkbox" id="precioDiferente" v-model="form.precioDiferente" />
                Precios diferentes adultos y niños
              </label>
            </div>

            <div class="form-group">
              <div class="mb-2">
                <div class="d-flex align-items-center">
                  <div class="mr-3">Precio {{ form.precioDiferente ? "PAX" : "" }} *:</div>
                  <div class="flex-fill">
                    <input type="text" class="form-control form-control-sm" v-model="form.precioPAX" />
                  </div>
                </div>
              </div>
              <div class="mb-2" v-if="form.precioDiferente">
                <div class="d-flex align-items-center">
                  <div class="mr-3">
                    Precio CHD *:
                  </div>
                  <div class="flex-fill">
                    <input type="text" class="form-control form-control-sm" v-model="form.precioCHD" />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <p class="form-label">Copiar de:</p>
            <div class="row form-row mb-2">
              <div class="col-6">
                <div class="form-group mb-1">
                  <label class="form-label" for="">Agencia: </label>
                  <InputSelect label="nombre" :reduce="(opt) => opt.idAgencia" v-model="form.copiar.idAgencia" :options="containers.agencias"></InputSelect>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-1">
                  <label class="form-label" for="">Servicio: </label>
                  <InputSelect label="nombre" :reduce="(opt) => opt.idServicio" v-model="form.copiar.idServicio" :options="containers.servicios"></InputSelect>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-1">
                  <label class="form-label" for="">Tipo: </label>
                  <InputSelect
                    label="sigla"
                    :reduce="(opt) => opt.idServicioTipo"
                    v-model="form.copiar.idServicioTipo"
                    :options="containers.copiar.tipos"
                    :disabled="loading.copiar.fetchServicios || loading.copiar.fetchTipos || !containers.copiar.tipos.length"
                  ></InputSelect>
                </div>
              </div>
              <div class="col-6 align-self-end">
                <div class="form-group mb-1">
                  <button class="btn btn-sm btn-light-primary btn-block" @click="onCopiar" :disabled="loading.copia">
                    Copiar
                  </button>
                </div>
              </div>
            </div>
            <div class="row form-row">
              <div class="col-6">
                <MyTable v-if="containers.paxs.length" :columns="containers.columnsPAXS" :body="paxDivididos[0]" :layout-fixed="true" small responsive tid="pax">
                  <template #rows="{ body: rows }">
                    <AgenciaPaxsItem v-for="item in rows" :key="item.pax" :item="item" />
                  </template>
                </MyTable>
              </div>
              <div class="col-6">
                <MyTable v-if="containers.paxs.length" :columns="containers.columnsPAXS" :body="paxDivididos[1]" :layout-fixed="true" small responsive tid="pax">
                  <template #rows="{ body: rows }">
                    <AgenciaPaxsItem v-for="item in rows" :key="item.pax" :item="item" />
                  </template>
                </MyTable>
              </div>
            </div>
          </template>
          <div class="form-group">
            <button class="btn btn-outline-success mr-2" @click="onNew">Nuevo</button>
            <button class="btn btn-primary" @click="onSave" :disabled="loading.crud">
              {{ containers.id ? "Actualizar" : "Guardar" }}
            </button>
          </div>
        </div>
        <div class="col-lg-8">
          <MyTable :columns="containers.columnsTarifas" :body="containers.tarifas" :layout-fixed="true" small responsive tid="idTarifa">
            <template #actions="{ row: item }">
              <button class="btn btn-xs btn-icon btn-light-warning mr-2" @click="onEdit(item)">
                <i class="fa fa-fw fa-pen"></i>
              </button>
              <button class="btn btn-xs btn-icon btn-light-danger" @click="onDelete(item)">
                <i class="fa fa-fw fa-trash-alt"></i>
              </button>
            </template>
            <template #fechaHoraModif="{ column }">
              {{ column && $dayjs(column).format("DD-MM-YY") }}
            </template>
            <template #porPasajero="{ column }">
              {{ column ? "SÍ" : "NO" }}
            </template>
            <template #difAdultoNino="{ column }">
              {{ column ? "SÍ" : "NO" }}
            </template>
          </MyTable>
        </div>
      </div>
    </template>
  </v-modal>
</template>
<script>
import InputSelect from "../modules/shared/components/InputSelect.vue";
const vModal = () => import(/* webpackChunkName: "ui-modal" */ "@/components/vModal");
const AgenciaPaxsItem = () => import("@/components/AgenciaPaxsItem");
const MyTable = () => import("@/components/MyTable");
export default {
  components: {
    vModal,
    AgenciaPaxsItem,
    MyTable,
    InputSelect,
  },
  props: ["show", "agencia"],
  data() {
    return {
      form: {
        servicio: "",
        tipo: "",
        precioPor: 1,
        precioDiferente: false,
        precioPAX: "",
        precioCHD: "",
        moneda: null,
        copiar: {
          idAgencia: "",
          idServicio: "",
          idServicioTipo: "",
        },
      },
      loading: {
        view: true,
        servicioTipos: false,
        fetchTipos: false,
        crud: false,
        save: false,
        copia: false,
        copiar: {
          fetchTipos: true,
        },
      },
      containers: {
        id: null,
        tarifas: [],
        servicios: [],
        tipos: [],
        monedas: [],
        columnsPAXS: [
          {
            key: "pax",
            label: "PAX",
            headClass: "text-center tlf-w-40",
          },
          {
            key: "precio",
            label: "Precio",
            headClass: "text-center",
          },
        ],
        columnsTarifas: [
          {
            key: "actions",
            label: "",
            headClass: "tlf-actions-2",
          },
          {
            key: "servicio",
            label: "Servicio",
            minWidth: 150,
          },
          {
            key: "tipo",
            label: "Tipo",
            headClass: "text-center tlf-acronym-2",
            bodyClass: "text-center",
          },
          {
            key: "porPasajero",
            label: "FIJO",
            headClass: "text-center tlf-acronym",
            bodyClass: "text-center",
          },
          {
            key: "moneda",
            label: "Moneda",
            headClass: "text-center tlf-acronym",
            bodyClass: "text-center",
          },
          {
            key: "precioAdulto",
            label: "PAX",
            headClass: "text-center tlf-w-60",
            bodyClass: "text-center",
          },
          {
            key: "precioNino",
            label: "CHD",
            headClass: "text-center tlf-w-60",
            bodyClass: "text-center",
          },
          {
            key: "fechaHoraModif",
            label: "Fecha M.",
            headClass: "tlf-date",
          },
          {
            key: "usuarioModif",
            label: "UM",
            headClass: "tlf-w-60",
          },
        ],
        paxs: [],
        agencias: [],
        copiar: {
          tipos: [],
        },
        isOnEdit: false,
      },
    };
  },
  async created() {
    let vm = this;

    let response = await vm.axios.get(`/mantenimiento/agencias/${vm.agencia.idAgencia}/tarifas`);

    vm.containers.tarifas = response.data.content.tarifas;
    vm.containers.servicios = response.data.content.servicios;
    vm.containers.agencias = response.data.content.agencias;
    vm.containers.monedas = response.data.content.monedas;

    vm.form.moneda = response.data.content.monedas[0].sigla;

    await vm.generateTablePaxs();

    vm.loading.view = false;
  },
  watch: {
    async "form.servicio"(newVal) {
      if (newVal) {
        this.containers.tipos = [];
        if (!this.containers.isOnEdit) this.form.tipo = "";
        this.loading.servicioTipos = true;
        let response = await this.fetchServicioTipos(newVal);
        this.containers.tipos = response.data.content;
        this.containers.isOnEdit = false;
        this.loading.servicioTipos = false;
      } else {
        this.containers.tipos = [];
        this.form.tipo = "";
      }
    },
    async "form.copiar.idServicio"(newVal) {
      if (newVal) {
        this.loading.copiar.fetchTipos = true;
        this.form.copiar.idServicioTipo = "";

        let response = await this.fetchServicioTipos(newVal);
        this.containers.copiar.tipos = response.data.content;

        this.loading.copiar.fetchTipos = false;
      } else {
        this.loading.copiar.fetchTipos = true;
        this.containers.copiar.tipos = [];
        this.form.copiar.idServicioTipo = "";
      }
    },
  },
  computed: {
    paxDivididos() {
      const vm = this;

      if (!vm.containers.paxs.length) return [];

      return [vm.containers.paxs.slice(0, 8), vm.containers.paxs.slice(8, 17)];
    },
    idPorMonedaSigla() {
      return this.containers.monedas.reduce((obj, item) => {
        obj[item.sigla] = item.idMoneda;
        return obj;
      }, {});
    },
    siglaMonedaPorId() {
      return this.containers.monedas.reduce((obj, item) => {
        obj[item.idMoneda] = item.sigla;
        return obj;
      }, {});
    },
  },
  methods: {
    async onSave() {
      let vm = this;
      let fd = {
        idServicio: vm.form.servicio,
        idServicioTipo: vm.form.tipo || null,
        pricePer: vm.form.precioPor,
        priceDifferent: vm.form.precioDiferente ? 1 : 0,
        idMoneda: vm.idPorMonedaSigla[vm.form.moneda],
        pricePAX: vm.form.precioPAX,
        priceCHD: vm.form.precioCHD,
        paxs: vm.containers.paxs,
        _method: "POST",
      };

      if (!fd.idServicio) return vm.$swal.fire("", "Seleccione un Servicio", "warning");

      if (fd.pricePer === 1) {
        // por pasajeros
        if (fd.priceDifferent) {
          if (!(fd.pricePAX && fd.priceCHD)) return vm.$swal.fire("", "Completa los campos obligatorios", "warning");
        } else {
          if (!fd.pricePAX) return vm.$swal.fire("", "Completa los campos obligatorios", "warning");
        }
      }

      vm.loading.crud = true;

      let endpoint = `/mantenimiento/agencias/${vm.agencia.idAgencia}/tarifas`;

      if (vm.containers.id) {
        endpoint = `/mantenimiento/agencias/${vm.agencia.idAgencia}/tarifas/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
        .post(endpoint, fd)
        .then((response) => {
          if (vm.containers.id) {
            let findRow = vm.containers.tarifas.find((item) => item.idTarifa === vm.containers.id);

            findRow.porPasajero = vm.form.precioPor;
            findRow.difAdultoNino = vm.form.precioPor ? vm.form.precioDiferente : 0;
            findRow.precioAdulto = vm.form.precioPor ? (vm.form.precioPAX ? Number(vm.form.precioPAX).toFixed(2) : "") : "";
            findRow.precioNino = vm.form.precioPor ? (vm.form.precioDiferente ? (vm.form.precioCHD ? Number(vm.form.precioCHD).toFixed(2) : "") : "") : "";
            findRow.fechaHoraModif = vm.$dayjs().format("YYYY-MM-DD HH:mm:ss");
            findRow.usuarioModif = vm.$store.state.user.codigo;
            findRow.moneda = vm.form.moneda;

            vm.generateTablePaxs(vm.form.precioPor ? null : vm.containers.id);
          } else {
            vm.containers.tarifas.push({
              servicio: vm.containers.servicios.find((item) => item.idServicio === vm.form.servicio).nombre,
              tipo: vm.form.tipo ? vm.containers.tipos.find((item) => item.idServicioTipo === vm.form.tipo).sigla : "",
              idServicio: vm.form.servicio,
              idServicioTipo: vm.form.tipo || "",
              porPasajero: vm.form.precioPor,
              difAdultoNino: vm.form.precioPor ? vm.form.precioDiferente : 0,
              precioAdulto: vm.form.precioPor ? (vm.form.precioPAX ? Number(vm.form.precioPAX).toFixed(2) : "") : "",
              precioNino: vm.form.precioPor ? (vm.form.precioDiferente ? (vm.form.precioCHD ? Number(vm.form.precioCHD).toFixed(2) : "") : "") : "",
              idTarifa: response.data.content.id,
              fechaHoraModif: vm.$dayjs().format("YYYY-MM-DD HH:mm:ss"),
              usuarioModif: vm.$store.state.user.codigo,
              moneda: vm.form.moneda,
            });

            vm.containers.id = response.data.content.id;

            if (vm.form.precioPor === 0) vm.generateTablePaxs(response.data.content.id);
          }

          if (vm.form.precioPor === 0) {
            vm.form.precioDiferente = false;
            vm.form.precioPAX = "";
            vm.form.precioCHD = "";
          }

          vm.$toast.fire(response.data.message, "", "success");
        })
        .catch((error) => {
          console.log("error", error);
          vm.$toast.fire(error.response.data.message, "", "error");
        })
        .finally(() => {
          vm.loading.crud = false;
        });
    },
    async onEdit(pItem) {
      const vm = this;

      vm.containers.isOnEdit = true;
      vm.form.servicio = pItem.idServicio;
      vm.form.tipo = pItem.idServicioTipo;
      vm.form.precioPor = pItem.porPasajero;
      vm.form.precioDiferente = pItem.difAdultoNino;
      vm.form.precioPAX = pItem.precioAdulto ? Number(pItem.precioAdulto).toFixed(2) : "";
      vm.form.precioCHD = pItem.precioNino ? Number(pItem.precioNino).toFixed(2) : "";
      vm.form.moneda = pItem.moneda;

      vm.containers.id = pItem.idTarifa;

      if (pItem.porPasajero === 0) {
        await vm.generateTablePaxs(pItem.idTarifa);
      } else {
        await vm.generateTablePaxs();
      }
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire("", "¿Seguro que desea eliminar este item?");

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
          .delete(`/mantenimiento/agencias/${vm.agencia.idAgencia}/tarifas/${pItem.idTarifa}`)
          .then((response) => {
            vm.containers.tarifas = vm.containers.tarifas.filter((item) => item.idTarifa !== pItem.idTarifa);
            vm.onNew();
            vm.$toast.fire(response.data.message, "", "success");
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
      }
    },
    async onNew() {
      await this.generateTablePaxs();
      this.form.servicio = "";
      this.form.tipo = "";
      this.form.precioPor = 1;
      this.form.precioDiferente = 0;
      this.form.precioPAX = "";
      this.form.precioCHD = "";
      this.form.moneda = this.containers.monedas[0].sigla;
      
      this.containers.paxs = [];

      this.form.copiar.idAgencia = null;
      this.form.copiar.idServicio = null;
      this.form.copiar.idServicioTipo = null;

      this.containers.id = null;
    },
    fetchServicioTipos(pIdServicio) {
      return this.axios.get(`/servicios/${pIdServicio}/tipos`);
    },
    async generateTablePaxs(idTarifa = null) {
      const vm = this;
      let responsePaxs = [];
      let paxs = {};
      vm.containers.paxs = [];

      if (idTarifa) {
        responsePaxs = await vm.axios.get(`/mantenimiento/agencias/${vm.agencia.idAgencia}/tarifas/${idTarifa}/paxs`);
        responsePaxs = responsePaxs.data.content.paxs;
      }

      for (let i = 1; i <= 16; i++) {
        paxs[i] = {
          pax: i,
          precio: "",
          usuario: "",
          id: 0,
          fechaHoraModif: "",
        };
      }

      responsePaxs.forEach((item) => {
        paxs[item.pax] = {
          ...paxs[item.pax],
          ...item,
          id: item.idTarifaPax,
        };
      });

      vm.containers.paxs = Object.values(paxs);
    },
    async onCopiar() {
      const vm = this;

      const form = {
        idAgencia: vm.form.copiar.idAgencia,
        idServicio: vm.form.copiar.idServicio,
        idServicioTipo: vm.form.copiar.idServicioTipo,
      };

      if (!(form.idAgencia && form.idServicio)) return vm.$swal.fire("", "Seleccione una Agencia y Servicio", "warning");

      vm.loading.copia = true;

      vm.axios
        .get(`/mantenimiento/agencias/${form.idAgencia}/tarifas/copiar`, {
          params: {
            idServicio: form.idServicio,
            idServicioTipo: form.idServicioTipo,
          },
        })
        .then((response) => {
          let tarifas = response.data.content.tarifas;

          if (!tarifas.length) {
            vm.loading.copia = false;
            return vm.$swal.fire("", "No existen registros para copiar", "info");
          }

          vm.containers.paxs.forEach((item) => {
            item.precio = "";
          });

          tarifas.forEach((tarifa) => {
            vm.containers.paxs.forEach((itemPax) => {
              if (itemPax.pax === tarifa.pax) itemPax.precio = tarifa.precio;
            });
          });

          vm.form.moneda = vm.siglaMonedaPorId[tarifas[0].idMoneda];

          vm.loading.copia = false;
        })
        .catch((error) => {
          vm.loading.copia = false;
        });
    },
  },
};
</script>
